import { useSelector } from 'react-redux';

import { selectWidgetExpanded } from '../selectors/widget';
import { useSkipFirstEffect } from './useSkipFirstEffect';

export const useOnWidgetExpanded = (callback: (expanded: boolean) => void): void => {
  const widgetExpanded = useSelector(selectWidgetExpanded);

  useSkipFirstEffect(() => {
    callback(widgetExpanded);
  }, [widgetExpanded]);
};
